<template>
  <Modal
    name="ONBOARDING_TERMS_MODAL"
    title="Termos e condições gerais dos serviços de intermediação digital"
  >
    <template v-slot:body>
      <div class="body-2">
        <p>
          Estes Termos e Condições Gerais de Serviços de Intermediação Digital
          (“Contrato”) constituem um negócio jurídico entre, conforme aplicável,
          uma pessoa física ou uma pessoa jurídica independente dedicada à
          prestação de serviços de HOST, adiante denominada “HOST” e HAUSEFUL
          SERVIÇOS DIGITAIS, pessoa jurídica de direito privado, inscrita no
          CNPJ sob o nº 30.668.299/0001-18, estabelecida na Rua Vitória Régia,
          64, Santa Mônica, Florianópolis, SC.
        </p>

        <p>
          A HAUSEFUL disponibiliza os serviços da plataforma HAUSEFUL (conforme
          definição abaixo) com a finalidade de viabilizar para o HOST a
          angariação e prospecção de clientes, geralmente Imobiliárias,
          denominados adiante de “Usuários”, para prestação de serviços de HOST.
        </p>

        <p>
          Os Serviços da HAUSEFUL permitem que um HOST ou EMPRESA DE HOST atenda
          solicitações de Serviços de HOST (conforme definição abaixo) por um
          Usuário (conforme definição abaixo) autorizado da plataforma móvel da
          HAUSEFUL.
        </p>

        <p>
          O HOST está autorizado a prestar Serviços de HOST e deseja celebrar
          este Contrato com a finalidade de acessar e usar os Serviços da
          HAUSEFUL para melhorar o seu serviço de HOST.
        </p>

        <p>
          O HOST reconhece e concorda que a HAUSEFUL se limita a fornecer
          serviços de intermediação mediante o uso de tecnologia, e não fornece
          Serviços de HOST e nem atua como uma empresa de HOST.
        </p>

        <p>
          Para utilizar os Serviços da HAUSEFUL, o HOST deve concordar com os
          termos e condições que são definidos abaixo. Após a assinatura
          (eletrônica ou de outra forma) do presente Contrato pelo HOST, o HOST
          e a HAUSEFUL ficarão obrigados aos termos e condições estabelecidos
          neste documento.
        </p>

        <h2>1. Uso dos Serviços da HAUSEFUL</h2>

        <p>
          <b>1.1. ID de HOST.</b>
          A HAUSEFUL emitirá ao(à) HOST um ID de HOST para cada HOST que prestar
          Serviços de HOST para permitir que o(a) HOST e cada HOST (quando
          aplicável) acessem e usem a plataforma de HOST em um Dispositivo de
          acordo com o Adendo de HOST (quando aplicável) e com o presente
          Contrato. O(A) HOST concorda em manter e assegurar que seus(suas)
          HOSTs (quando aplicável) manterão o ID de HOST em sigilo e não o
          compartilharão com terceiros(as) além do(a) HOST associado(a) a esse
          ID de HOST para os fins de prestação de Serviços de HOST. O(A) HOST
          notificará imediatamente a HAUSEFUL caso ocorra qualquer violação ou
          uso inadequado, efetivo ou potencial, do ID de HOST ou da plataforma
          de HOST.
        </p>

        <p>
          <b>1.2. Prestação de Serviços de HOST.</b>
          Quando a plataforma de HOST estiver ativa, as solicitações de
          Usuário(as) para Serviços de HOST poderão aparecer ao(à) HOST por meio
          da plataforma de HOST se o(a) HOST estiver conectado no aplicativo da
          HAUSEFUL e disponível na região do(a) Usuário(a). Se o(a) HOST aceitar
          a solicitação do(a) Usuário(a) para Serviços de HOST, os Serviços da
          HAUSEFUL disponibilizarão determinadas Informações de Usuário(a) ao(à)
          HOST por meio da plataforma de HOST, inclusive o primeiro nome do(a)
          Usuário(a). O(A) HOST reconhece e concorda que uma vez que o(a) HOST
          aceite uma solicitação do(a) Usuário(a) para Serviços de HOST, os
          Serviços da HAUSEFUL poderão disponibilizar certas informações sobre
          o(a) HOST ao Usuário(a), incluindo o primeiro nome e informações de
          contato do(a) HOST, nome social do HOST, HOST e endereço do(a) HOST.
          O(A) HOST poderá contatar o usuário quando necessário, porém não
          poderá utilizar nenhum dado pessoal do usuário por qualquer motivo que
          não seja a prestação de Serviços de HOST. Entre a HAUSEFUL e o(a)
          HOST, o(a) HOST reconhece e concorda que: (a) o(a) HOST e seus(suas)
          HOSTs (quando aplicável) são os(as) únicos(as) responsáveis por
          determinar a forma mais eficaz, eficiente e segura para executar cada
          etapa dos Serviços de HOST; e (b) exceto em relação aos Serviços da
          HAUSEFUL ou quaisquer Dispositivos da HAUSEFUL (se aplicável), o(a)
          HOST deve fornecer todos os equipamentos, ferramentas e outros
          materiais necessários para a prestação dos Serviços de HOST, sob sua
          conta e risco.
        </p>

        <p>
          <b>1.3. Relacionamento do(a) HOST com os(as) Usuários(as). </b>
          O(A) HOST RECONHECE E CONCORDA QUE A PRESTAÇÃO DOS SERVIÇOS DE HOST
          DO(A) HOST AOS USUÁRIOS(AS) NÃO OCORRE COM A PARTICIPAÇÃO DA HAUSEFUL.
          DESTA FORMA, A HAUSEFUL NÃO É RESPONSÁVEL PELAS AÇÕES OU OMISSÕES DE
          UM(A) USUÁRIO(A) EM RAZÃO DE CONDUTAS DO(A) HOST. O(A) HOST SERÁ O(A)
          ÚNICO(A) RESPONSÁVEL POR QUAISQUER OBRIGAÇÕES OU RESPONSABILIDADES EM
          RELAÇÃO AOS(ÀS) USUÁRIOS(AS) OU TERCEIROS(AS) DECORRENTES DE SUA
          PRESTAÇÃO DE SERVIÇOS DE HOST. EM RELAÇÃO AOS CLIENTES DOS USUÁRIOS,
          CABE AO HOST REPASSÁ-LOS ÀS INFORMAÇÕES FIDEDIGNAS SOBRE OS SERVIÇOS
          REALIZADOS. O(A) HOST RECONHECE E CONCORDA QUE A HAUSEFUL
          DISPONIBILIZA INFORMAÇÕES DE CONTATO DO(A) HOST E/OU DE UM(A) HOST
          PARA UM(A) USUÁRIO(A) ATRAVÉS DE SUA PLATAFORMA.
        </p>

        <p>
          <b>1.4. Relacionamento do(a) HOST com a HAUSEFUL.</b>
          O(A) HOST reconhece e concorda que a disponibilização da plataforma de
          HOST e dos Serviços da HAUSEFUL ao(à) HOST pela HAUSEFUL cria uma
          relação jurídica e comercial direta entre a HAUSEFUL e o(a) HOST. A
          HAUSEFUL não administra, nem controla, nem será considerada
          administradora ou controladora do(a) HOST ou seus(suas) HOSTs (quando
          aplicável) de forma geral ou em relação ao cumprimento dos termos
          deste Contrato especificamente, incluindo o que diz respeito à
          operação do negócio do(a) HOST, à prestação de Serviços de HOST e os
          atos ou omissões dos(as) HOSTs. O(A) HOST e seus(as) HOSTs detêm o
          direito exclusivo de determinar quando e por quanto tempo cada um(a)
          deles(as) utilizará a plataforma de HOST ou os Serviços da HAUSEFUL.
          O(A) HOST e seus(suas) HOSTs manterão a faculdade, através da
          plataforma de HOST, de aceitar, recusar ou ignorar a solicitação de
          um(a) Usuário(a) para Serviços de HOST através dos Serviços da
          HAUSEFUL, ou cancelar um pedido aceito para Serviços de HOST, através
          da plataforma de HOST, sujeito às políticas de cancelamento da
          HAUSEFUL vigentes na ocasião. O(A) HOST não irá, e assegurará que
          seus(suas) HOSTs (quando aplicável) não irão: (a) exibir nomes,
          logotipos ou cores da HAUSEFUL ou de quaisquer de suas Afiliadas; ou
          (b) usar um uniforme ou qualquer outra peça de vestuário que apresente
          os nomes, logotipos ou cores da HAUSEFUL ou de qualquer uma de suas
          Afiliadas. O supramencionado não se aplicará na hipótese do(a) HOST e
          a HAUSEFUL terem acordado de outra forma ou se assim for exigido por
          lei. O(A) HOST reconhece e concorda que tem total liberdade para
          conduzir seu negócio independentemente e orientar seus(suas) HOSTs
          (quando aplicável), a seu critério, inclusive em relação à
          possibilidade de prestar serviços a qualquer momento para quaisquer
          terceiros(as) separadamente e aparte dos Serviços de HOST. Para fins
          de clareza, o(a) HOST entende que tem o pleno direito de prestar
          serviços de HOST aos seus atuais consumidores e usar outros serviços
          de Plataforma s de software, além dos serviços da HAUSEFUL. A HAUSEFUL
          reserva o direito de, a qualquer momento, a seu exclusivo critério,
          desativar ou restringir o(a) HOST ou qualquer HOST de acessar ou
          utilizar a plataforma de HOST ou os Serviços da HAUSEFUL caso ocorra
          uma violação do presente Contrato, violação do Adendo de HOST,
          difamação da HAUSEFUL ou qualquer uma de suas Afiliadas por parte
          do(a) HOST ou de qualquer HOST (quando aplicável), qualquer ato ou
          omissão do(a) HOST ou de qualquer HOST (quando aplicável) que
          comprovadamente cause dano à marca, reputação ou negócios da HAUSEFUL
          ou suas Afiliadas.
        </p>

        <p>
          <b
            >1.5. Relacionamento do(a) HOST com os(as) HOSTs, no caso de HOSTs
            que não sejam Pessoas Físicas.</b
          >
          O(A) HOST será o(a) único(a) responsável por quaisquer obrigações ou
          responsabilidades em relação aos(às) HOSTs que decorram do seu
          relacionamento com tais HOSTs (incluindo a prestação de Serviços de
          HOST). O(A) HOST reconhece e concorda que exercerá o controle
          exclusivo sobre os(as) HOSTs e cumprirá com todas as leis (inclusive
          tributárias, securitárias e trabalhistas) que regem ou ainda que de
          alguma forma se apliquem à sua relação com os(as) HOSTs. Sem prejuízo
          ao direito do(a) HOST, se for o caso, de adotar medidas contra um(a)
          HOST, o(a) HOST reconhece e aceita que será sempre responsável pelos
          atos e omissões de seus(suas) HOSTs perante os(as) Usuários(as) da
          HAUSEFUL, mesmo quando essa responsabilidade possa não ser atribuída
          de acordo com a lei aplicável. O(A) HOST deve exigir que cada HOST
          assine um Adendo de HOST (que poderá ser atualizado de tempos em
          tempos) e deve fornecer uma cópia de cada Adendo de HOST assinado à
          HAUSEFUL. O(A) HOST reconhece e concorda que a HAUSEFUL é uma terceira
          beneficiária de cada Adendo de HOST, e que, mediante a formalização do
          Adendo de HOST por parte do(a) HOST (eletronicamente ou de outra
          forma), a HAUSEFUL terá o direito irrevogável (e será considerada como
          tendo aceito o direito a menos que o tenha rejeitado imediatamente
          após o recebimento de uma cópia do Adendo de HOST assinado) de fazer
          cumprir o Adendo de HOST contra o(a) HOST, como terceira beneficiária
          do documento.
        </p>

        <h2>1.6 Avaliação</h2>

        <p>
          <b>1.6.1.</b>
          O(A) HOST reconhece e concorda que: (i) após prestar Serviços de HOST,
          a Plataforma da HAUSEFUL solicitará ao(à) Usuário(a) que faça uma
          avaliação desse Serviço de HOST, do(a) HOST e, opcionalmente, comente
          esse Serviço de HOST e o(a) HOST; e (ii) após a prestação de Serviços
          de HOST, a Plataforma solicitará ao(à) HOST que faça uma avaliação
          do(a) Serviço e, opcionalmente, comente os detalhes do serviço. O HOST
          deverá instruir todos(as) os(as) HOSTs a fazerem avaliações e
          comentários de boa fé.
        </p>

        <p>
          <b>1.6.2.</b>
          O(A) HOST reconhece que a HAUSEFUL deseja que os(as) Usuários(as)
          tenham acesso a serviços de alta qualidade por meio da Plataforma da
          HAUSEFUL. Para continuar a receber acesso a Plataforma de HOST e aos
          Serviços da HAUSEFUL, o(a) HOST reconhece que precisará manter uma
          avaliação média de pontos, dada(s) pelos(as) Usuários(as), que exceda
          a avaliação média mínima aceitável pela HAUSEFUL, conforme for
          atualizada pela HAUSEFUL, a qualquer momento e a seu exclusivo
          critério (“Avaliação Média Mínima”). Caso a média de avaliação do(a)
          HOST fique abaixo da Avaliação Média Mínima, a HAUSEFUL notificará
          o(a) HOST poderá dar ao(à) HOST, a critério da HAUSEFUL, um prazo
          limitado para que busque melhor sua(s) avaliação(s) pelo (s) Usuário
          (s) a fim de elevar a sua média de avaliação para acima da Avaliação
          Média Mínima. Caso o(a) HOST não eleve sua média de avaliação acima da
          Avaliação Média Mínima no prazo que lhe foi concedido (se for o caso),
          a HAUSEFUL poderá desativar o acesso desse(a) HOST a Plataforma de
          HOST e aos Serviços da HAUSEFUL.
          <u
            >Ademais, o(a) HOST reconhece e concorda que se o HOST desistir do
            trabalho sem comunicar com antecedência o(s) usuário(s), chegar
            atrasado no compromisso, vestir-se de forma inadequada para o
            exercício de HOST, não atender a qualidade mínima exigida na
            Avaliação Média Mínima e deixar reiteradamente de aceitar
            solicitações de Usuário(a) para Serviços de HOST enquanto o(a) HOST
            estiver conectado(a) a Plataforma de HOST isso cria uma experiência
            negativa para os(as) Usuários da plataforma móvel HAUSEFUL. Assim
            sendo, o(a) HOST concorda e assegura que, caso um(a) HOST não deseje
            aceitar solicitações de Usuários para Serviços de HOST por um
            período de tempo, esse(a) HOST deverá se desconectar da plataforma
            de HOST.
          </u>
        </p>

        <p>
          <b>1.6.3.</b>
          A HAUSEFUL e suas Afiliadas se reservam o direito de usar,
          compartilhar e exibir as avaliações do(a) HOST e avaliações e
          comentários de Usuário(a) de qualquer modo relacionada aos negócios da
          HAUSEFUL e suas Afiliadas sem atribuí-las ao(à) HOST ou HOST, sem sua
          aprovação. O(A) HOST reconhece que a HAUSEFUL e suas Afiliadas são
          distribuidores (sem nenhuma obrigação de confirmação) e não editores
          das avaliações e comentários de HOST e de Usuário(a), sendo certo que
          a HAUSEFUL e suas Afiliadas reservam o direito de reduzir ou remover
          comentários que incluam obscenidades ou outros conteúdos inadequados,
          inclusive o nome de uma pessoa ou outras informações pessoais, ou que
          violem leis de privacidade, outras leis aplicáveis ou políticas de
          conteúdo da HAUSEFUL ou de suas Afiliadas.
        </p>

        <h2>1.7. Dispositivos</h2>

        <p>
          <b>1.7.1.</b>
          A HAUSEFUL incentiva o(a) HOST a usar Dispositivo fornecido por HOST
          para a prestação dos Serviços de HOST. Caso contrário, a HAUSEFUL
          poderá fornecer ao(à) HOST, mediante solicitação, Dispositivos da
          HAUSEFUL para cada HOST autorizado(a) e poderá fornecer plano de dados
          locação de equipamentos sem fio necessário para tais Dispositivos,
          sendo certo que a HAUSEFUL exigirá o reembolso do(a) HOST pelos custos
          associados ao plano de dados sem fio locação de cada Dispositivo da
          HAUSEFUL e/ou solicitará um depósito para cada Dispositivo da
          HAUSEFUL. O(A) HOST reconhece e concorda que: (a) os Dispositivos da
          HAUSEFUL somente podem ser usados para permitir que o(a) HOST acesse e
          use os Serviços da HAUSEFUL; e (b) os Dispositivos da HAUSEFUL não
          podem ser transferidos, emprestados, vendidos nem, de qualquer modo,
          disponibilizados de alguma forma a qualquer terceiro que não o(a) HOST
          designado para usar o Dispositivo da HAUSEFUL. Os Dispositivos da
          HAUSEFUL devem permanecer sempre como propriedade da HAUSEFUL, e ao
          término do presente Contrato ou quando da rescisão ou desativação de
          um(a) HOST, o(a) HOST concorda em devolver à HAUSEFUL os respectivos
          Dispositivos da HAUSEFUL no prazo de dez (48) horas. O(A) HOST
          reconhece e concorda que a não devolução no prazo acordado de
          quaisquer Dispositivos da HAUSEFUL, ou danos aos Dispositivos da
          HAUSEFUL que excedam o “desgaste natural” decorrente do uso, resultará
          na perda dos depósitos relacionados aos Dispositivos da HAUSEFUL.
        </p>

        <p>
          <b>1.7.2.</b>
          Se o(a) HOST optar por usar qualquer Dispositivo fornecido por HOST:
          (i) o(a) HOST e/ou seus(suas) HOSTs serão responsáveis pela aquisição,
          custos e manutenção desse Dispositivo Fornecido por HOST assim como
          por qualquer plano de dados sem fio necessário; e (ii) a HAUSEFUL
          disponibilizará a plataforma de HOST para instalação no Dispositivo
          Fornecido por HOST. A HAUSEFUL concede ao(à) usuário(a) autorizado(a)
          de qualquer Dispositivo Fornecido por HOST uma licença pessoal, não
          exclusiva e não transferível de direito de usuário(a) para instalar e
          utilizar a plataforma de HOST em um Dispositivo Fornecido por HOST
          somente para a finalidade da prestação de Serviços de HOST. O(A) HOST
          concorda em não fornecer, distribuir ou compartilhar, nem permitir o
          fornecimento, distribuição ou compartilhamento da Plataforma do HOST
          (nem de qualquer dado relacionado) a terceiros(as). O direito acima se
          encerrará imediatamente e o(a) HOST apagará e removerá integralmente a
          plataforma de HOST do Dispositivo Fornecido por HOST caso o(a) HOST
          e/ou o(a) HOST deixe(m) de prestar(em) Serviços de HOST usando o
          Dispositivo Fornecido por HOST. O(A) HOST concorda e informará cada
          HOST aplicável que: (i) o uso da plataforma de HOST em um Dispositivo
          Fornecido por HOST demanda um plano de dados ativo com um provedor de
          serviço sem fio associado ao Dispositivo fornecido por HOST, plano de
          dados este que deverá ser providenciado pelo(a) HOST de HOST ou
          pelo(a) HOST, às suas expensas; e (ii) o uso da plataforma de HOST em
          um Dispositivo Fornecido por HOST como interface com os Serviços da
          HAUSEFUL poderá consumir grandes quantidades de dados de plano de
          dados. A HAUSEFUL recomenda que o Dispositivo Fornecido por HOST
          somente seja usado em um plano de dados ilimitado ou com limites bem
          elevados sendo que a HAUSEFUL não será responsável por nenhuma taxa,
          custo ou excedente de limite relacionado a qualquer plano de dados.
        </p>

        <h2>2. Termos Financeiros</h2>

        <p>
          <b>2.1. Do Preço fixado pelo HOST ao Usuário.</b>
          O(A) HOST tem o direito de ACEITAR OU NÃO o preço, ofertado(s) pelo(s)
          Usuário(s), por cada etapa encerrada dos Serviços de HOST prestados
          aos(às) Usuários(as) que forem identificados através dos Serviços da
          HAUSEFUL (“Preço Total do Serviço de HOST”):
        </p>

        <p>
          <b>2.2. Do Pagamento.</b>
          Com o objetivo de financiar os custos operacionais de manutenção da
          plataforma tecnológica, incluindo custos necessários ao
          desenvolvimento de alternativas voltadas à segurança dos HOSTs e
          Usuários, o(a) HOST reconhece que pagará à HAUSEFUL até 50% (cinquenta
          por cento) do valor de cada Serviço de HOST prestado para o(a)
          Usuário(a) mediante a utilização dos Serviços da HAUSEFUL.
          <b
            >Referido valor, já descontada a taxa da HAUSEFUL, deverá constar na
            oferta do serviço no aplicativo do HOST.
          </b>
        </p>

        <p>
          <b>2.2. Da forma de pagamento.</b>
          O pagamento deverá ser efetuado quinzenalmente, através de
          transferência bancária na conta do HOST, informada dentro do
          aplicativo do HOST.
        </p>

        <p>
          <b>2.3. Nenhum Valor Adicional.</b>
          O(A) HOST reconhece e concorda que, para o mútuo benefício das partes,
          através de publicidade e marketing, a HAUSEFUL e suas Afiliadas
          poderão buscar e atrair novos(as) Usuários(as) para a HAUSEFUL e
          aumentar o número de Usuários(as) que utilizam a plataforma Móvel
          HAUSEFUL. O(A) HOST reconhece e concorda que tal publicidade ou
          marketing não dá direito ao(à) HOST a quaisquer quantias monetárias
          adicionais, além dos montantes expressamente fixados neste Contrato.
        </p>

        <p>
          <b>2.4. Impostos.</b>
          O(A) HOST reconhece e concorda que deve realizar todas as obrigações
          de registro fiscal, calcular e remeter todas as obrigações tributárias
          relacionadas com a prestação de Serviços de HOST, conforme exigido
          pela legislação aplicável. O(A) HOST reconhece e concorda que o(a)
          HOST e cada um(a) dos(as) HOSTs é responsável pelos tributos sobre os
          seus próprios rendimentos, resultantes da prestação de Serviços de
          HOST. Sem prejuízo de qualquer disposição em contrário no presente
          Contrato, a HAUSEFUL pode, a seu critério, com base em considerações
          tributárias e regulatórias aplicáveis, recolher e remeter os tributos
          resultantes da prestação de Serviços de HOST do(a) HOST e/ou de
          qualquer HOST e/ou disponibilizar qualquer informação fiscal relevante
          que o(a) HOST e/ou qualquer HOST tenha disponibilizado em conformidade
          com os requisitos mencionados nesta Cláusula 2.4. diretamente às
          autoridades fiscais governamentais aplicáveis em nome do(a) HOST e/ou
          do(a) HOST aplicável ou de qualquer outra maneira.
        </p>

        <h2>3. Direitos de Propriedade; Licença</h2>

        <p>
          <b>3.1. Concessão da Licença.</b>
          Sujeito aos termos e condições deste Contrato, a HAUSEFUL por força do
          presente concede ao(à) HOST uma licença não exclusiva, isenta de
          royalties, não transferível, não sublicenciável e não transferível,
          durante a vigência do presente Contrato, para acessar e usar (e
          permitir que seus(suas) HOSTs acessem e usem) a plataforma de HOST em
          relação à prestação dos Serviços da HAUSEFUL exclusivamente para a
          finalidade de prestar Serviços de HOST aos(às) Usuários(as) e
          rastreamento resultante dos Preços e Taxas. Todos os direitos não
          expressamente concedidos ao(à) HOST são reservados pela HAUSEFUL, suas
          Afiliadas e seus respectivos licenciadores.
        </p>

        <p>
          <b>3.2. Restrições. </b>
          O(a) HOST não deve, e não deve permitir que nenhuma outra parte: (a)
          licenciar, sublicenciar, vender, revender, transferir, ceder,
          distribuir ou de alguma fornecer ou disponibilizar os Serviços da
          HAUSEFUL, a plataforma de HOST ou qualquer Dispositivo da HAUSEFUL de
          qualquer forma a qualquer outra parte; (b) modificar ou criar
          trabalhos derivados baseados nos Serviços da HAUSEFUL ou Plataforma de
          HOST; (c) usar indevidamente os Serviços da HAUSEFUL ou Plataforma de
          HOST, incluindo a criação de “links” de Internet com qualquer parte
          dos Serviços da HAUSEFUL ou Plataforma de HOST, “modulando”(framing)
          ou “refletindo” (mirroring) qualquer parte dos Serviços da HAUSEFUL ou
          Plataforma de HOST em quaisquer outros websites ou sistemas,
          “extraindo” (scraping) informações ou ainda obtendo dados
          indevidamente a partir dos Serviços da HAUSEFUL ou Plataforma de HOST;
          (d) fazer engenharia reversa, decompilar, modificar ou desmontar os
          Serviços da HAUSEFUL ou Plataforma de HOST, exceto quando permitido
          pela legislação aplicável; ou (e) enviar spam ou de qualquer forma
          mensagens duplicadas ou não solicitadas. Adicionalmente, o(a) HOST não
          deve acessar ou utilizar os Serviços da HAUSEFUL ou Plataforma de HOST
          nem deve permitir que qualquer outra parte acesse ou utilize os
          Serviços da HAUSEFUL ou Plataforma de HOST para: (i) projetar ou
          desenvolver um produto ou serviço concorrente ou substancialmente
          similar; (ii) copiar ou extrair quaisquer características,
          funcionalidades ou conteúdos destes; (iii) lançar ou fazer com que
          seja lançado em conexão com os Serviços da HAUSEFUL um programa ou
          script automatizado, incluindo web spiders, crawlers, robôs,
          indexadores, bots, vírus ou worms ou qualquer programa que possa fazer
          várias solicitações ao servidor por segundo, ou sobrecarregue ou
          dificulte indevidamente a operação e/ou desempenho dos Serviços da
          HAUSEFUL; ou (iv) tentar obter acesso não autorizado aos Serviços da
          HAUSEFUL ou seus sistemas ou redes relacionadas, em todos casos
          ressalvada a ocasião em que tais ações devam ser autorizadas pela
          legislação aplicável.
        </p>

        <p>
          <b>3.3. Propriedade.</b>
          Os Serviços da HAUSEFUL, Plataforma de HOST e Dados da HAUSEFUL,
          incluindo todos os direitos de propriedade intelectual relacionados a
          estes, bem como os Dispositivos da HAUSEFUL são e continuarão a ser
          propriedade da HAUSEFUL, suas Afiliadas e seus respectivos
          licenciadores. Nem este Contrato ou o uso dos Serviços da HAUSEFUL,
          Plataforma de HOST ou Dados da HAUSEFUL por parte do(a) HOST transfere
          ou concede ao(à) HOST quaisquer direitos: (a) sobre ou em relação aos
          Serviços da HAUSEFUL, a plataforma de HOST ou Dados da HAUSEFUL,
          exceto pela licença limitada concedida acima; ou (b) à utilização ou
          referência, de qualquer maneira, aos nomes, logotipos, nomes de
          produtos e serviços, marcas registradas ou marcas de serviço ou outros
          indícios de propriedade da HAUSEFUL, suas Afiliadas, ou seus
          respectivos licenciadores. Além disso, o(a) HOST reconhece o direito
          da HAUSEFUL à família de marcas e nomes HAUSEFUL, inclusive HAUSEFUL,
          isoladamente, e sua combinação com outras letras, pontuação, palavras,
          símbolos e/ou desenhos, o logotipo HAUSEFUL e logo de PARCEIRO
          (“Marcas e Nomes da HAUSEFUL”). O(A) HOST concorda que não irá, e
          assegurará que seus(suas) HOSTs não irão tentar registrar ou de alguma
          forma reivindicar a titularidade de qualquer uma das Marcas e Nomes da
          HAUSEFUL, isoladamente ou em combinação com outras letras, pontuação,
          palavras, símbolos e/ou desenhos, nem de qualquer marca ou nome
          similar que possa gerar confusão.
        </p>

        <h2>4. Confidencialidade</h2>

        <p>
          <b>4.1.</b>
          Cada uma das partes reconhece e concorda que, no cumprimento do
          presente Contrato, poderão ter acesso ou poderão ser expostas, direta
          ou indiretamente, às informações confidenciais da outra parte
          (“Informações Confidenciais”). Informações Confidenciais incluem Dados
          da HAUSEFUL, IDs de HOSTs, Informações de Usuário(a) e volume de
          transações, planos de marketing e negócio, vendas, informações
          financeiras, técnicas, operacionais e outras informações não públicas
          de cada parte (seja divulgada por escrito ou verbalmente) que tal
          parte determine como proprietárias ou confidenciais ou que a outra
          parte deveria razoavelmente saber que devem ser tratadas como
          confidenciais.
        </p>

        <p>
          <b>4.2.</b>
          Cada parte reconhece e concorda que: (a) todas as Informações
          Confidenciais permanecerão de propriedade exclusiva da parte
          divulgadora; (b) não deve usar as informações confidenciais da outra
          parte para qualquer finalidade, salvo para fins do presente Contrato;
          (c) não deve divulgar Informações Confidenciais da outra parte a
          terceiros, exceto aos seus empregados(as), funcionários(as),
          contratados(as), representantes e prestadores(as) de serviços
          (“Pessoas Permitidas”) quando necessário para o cumprimento do
          presente Contrato, desde que as Pessoas Permitidas estejam vinculadas,
          por escrito, à obrigações de confidencialidade e não utilização de
          Informações Confidenciais não menos rigorosas do que as contidas no
          presente; e (d) devolverá ou destruirá todas as Informações
          Confidenciais da parte divulgadora quanto da denúncia do presente
          Contrato ou a pedido da outra parte (sujeito à legislação aplicável e,
          com que diz respeito à HAUSEFUL, aos seus requisitos de manutenção de
          registros internos).
        </p>

        <p>
          <b>4.3.</b>
          Sem prejuízo do acima disposto, as Informações Confidenciais não
          incluem nenhuma informação que: (i) seja ou se torne parte do domínio
          público sem ação ou omissão por parte do destinatário(a); (ii) era
          detida pela parte receptora antes da data do presente Contrato, sem
          uma obrigação de confidencialidade; (iii) for divulgada para a parte
          receptora por um terceiro(a) sem obrigação de confidencialidade com
          relação às informações; ou (iv) tenham que ser divulgada em
          conformidade com uma lei, ordem judicial, intimação ou autoridade
          governamental, sendo certo que a parte receptora notificará a parte
          reveladora acerca desse fato e dará a parte divulgadora uma
          oportunidade razoável para contestar ou limitar tal divulgação
          obrigatória.
        </p>

        <h2>5. Privacidade</h2>

        <p>
          A HAUSEFUL se compromete a cumprir a legislação de proteção de dados
          aplicável incluindo, mas não se limitando a Lei nº 12.965/14 (Marco
          Civil da Internet), o Decreto nº. 8.771/2016 que a regulamentou, bem
          como com a Lei nº 13.709/18 (“LGPD”). São considerados (i) “Dados
          Pessoais”, em geral, quaisquer dados relacionados à pessoa natural
          identificada ou identificável, inclusive números identificativos,
          dados geolocacionais ou identificadores eletrônicos, que a HAUSEFUL
          venha a ter acesso no âmbito da execução do presente CONTRATO,
          incluindo dados pessoais de colaboradores, prestadores de serviços,
          funcionários e clientes dos HOSTs, e (ii) “Tratamento” de Dados
          Pessoais quaisquer operações, que se referem à coleta, produção,
          recepção, classificação, utilização, acesso, reprodução,
          processamento, armazenamento, eliminação, avaliação ou controle da
          informação, modificação, comunicação, transferência ou extração de
          Dados Pessoais. A HAUSEFUL se compromete a realizar o tratamento dos
          Dados Pessoais somente nos estritos limites para atingir a finalidade
          que motivou a presente contratação, não devendo a HAUSEFUL praticar
          qualquer tipo de ato estranho ao objeto do CONTRATO sem a prévia e
          expressa autorização dos HOSTs. A HAUSEFUL se compromete a: (i) adotar
          medidas de segurança técnicas e administrativas aptas a proteger os
          Dados Pessoais dos HOSTs de acessos não autorizados e de situações
          acidentais ou ilícitas de destruição, perda, alteração, comunicação ou
          qualquer forma de tratamento inadequado ou ilícito; (ii) obter prévia
          aprovação dos HOSTs para subcontratar terceiros para o Tratamento de
          Dados Pessoais dos HOSTs (“Subcontratado”) e assegurar contratualmente
          que eventual Subcontratado cumpra com a legislação de proteção de
          dados, inclusive em relação à implementação de boas práticas e medidas
          de governança corporativa e técnicas, como sistemas de tecnologia da
          informação aptos a combater eventuais ataques cibernético, vazamento,
          perda de integridade e qualquer outra forma de incidente e tratamento
          ilícito de Dados Pessoais; (iii) notificar os HOSTs imediatamente caso
          tome conhecimento de um incidente de segurança que envolva os Dados
          Pessoais dos HOSTs, inclusive na hipótese do incidente ter sido
          causado pelo Subcontratado, informando quais dados foram afetados e os
          riscos relacionados ao incidente; (iv) atender diretamente às
          solicitações dos titulares ou solicitações que forem enviadas pelos
          HOSTs a pedido dos titulares relacionadas ao acesso, apagamento,
          atualização, correção e portabilidade de Dados Pessoais; e (v) cumprir
          a legislação nacional aplicável e atender às ordens de autoridades
          nacionais, caso o Tratamento dos Dados Pessoais dos HOSTs pela
          HAUSEFUL ocorra fora dos limites territoriais do Brasil. Após o
          término ou rescisão deste Contrato, a HAUSEFUL deverá (i) transferir
          para os HOSTs ou qualquer terceiro de sua escolha os Dados Pessoais
          dos HOSTs, sem qualquer ônus; (ii) excluir de sua base de dados os
          Dados Pessoais dos HOSTs, salvo se a HAUSEFUL legalmente estiver
          obrigada a manter temporariamente tais dados; e (iii) garantir a
          segurança da informação dos Dados Pessoais dos HOSTs, mesmo após o
          término ou rescisão do CONTRATO e/ou do Tratamento de Dados Pessoais
          dos HOSTs. A HAUSEFUL, ora agente operador para fins da LGPD,
          reconhece sua responsabilidade no tratamento de dados em nome dos
          HOSTS, e, caso ocorra (a) violação das medidas legalmente previstas de
          proteção e tratamento de dados e/ou (b) Tratamento de Dados Pessoais
          dos HOSTs em desconformidade com as instruções dos HOSTs, responderá
          solidariamente perante terceiros, inclusive autoridades
          governamentais.
        </p>

        <h2>
          6. Declarações e Garantias; Declaração de Isenção de Responsabilidade
        </h2>

        <p>
          <b>6.1. Pelo(a) HOST.</b>
          O(A) HOST declara e garante que: (a) tem plenos poderes e autoridade
          para celebrar este Contrato e cumprir com as obrigações contratuais
          fixadas no presente; (b) está devidamente constituído(a), validamente
          existente e idôneo(a) sob as leis da jurisdição de sua origem; (c) não
          celebrou, e durante a vigência deste não celebrará, nenhum acordo que
          o(a) impeça de cumprir este Contrato;
        </p>

        <p>
          <b>6.2. ISENÇÃO DE GARANTIAS.</b>
          A HAUSEFUL OFERECE, E O(A) HOST ACEITA, OS SERVIÇOS DA HAUSEFUL, A
          PLATAFORMA DE HOST E OS DISPOSITIVOS DA HAUSEFUL “TAL COMO SE
          ENCONTRAM” E “CONFORME DISPONÍVEIS”. A HAUSEFUL NÃO DECLARA, ASSEGURA
          OU GARANTE QUE QUALQUER ACESSO POR HOSTS OU HOSTS OU USO DOS SERVIÇOS
          DA HAUSEFUL, DA PLATAFORMA DE HOST OU DOS DISPOSITIVOS DA HAUSEFUL:
          (A) SERÁ ININTERRUPTO OU LIVRE DE ERROS; OU (B) RESULTARÁ EM QUAISQUER
          SOLICITAÇÕES DE SERVIÇOS. AS FUNÇÕES DA HAUSEFUL SÃO APENAS DE UMA
          INTERMEDIAÇÃO SOB DEMANDA E SERVIÇOS CORRELATOS, NÃO SE
          RESPONSABILIZA, AUTORIZA OU DÁ GARANTIAS QUANTO A AÇÕES OU OMISSÕES
          DOS(AS) USUÁRIOS(AS) QUE POSSAM SOLICITAR OU RECEBER SERVIÇOS DE HOST
          DO(A) HOST OU QUALQUER HOST NOS TERMOS DO PRESENTE, E A HAUSEFUL
          TAMBÉM NÃO PRECISA SELECIONAR OU DE OUTRA FORMA AVALIAR OS(AS)
          USUÁRIOS(AS). AO USAR OS SERVIÇOS DA HAUSEFUL E A PLATAFORMA DE HOST,
          O(A) HOST RECONHECE E CONCORDA QUE O(A) HOST OU O(A) HOST PODEM LIDAR
          COM TERCEIROS (INCLUINDO OS(AS) USUÁRIOS(AS)) QUE PODEM REPRESENTAR
          PREJUÍZOS OU RISCO AO(À) HOST, AO(À) HOST OU TERCEIROS(AS). O(A) HOST
          E OS(AS) HOSTS SÃO ACONSELHADOS A ADOTAREM PRECAUÇÕES RAZOÁVEIS EM
          RELAÇÃO ÀS INTERAÇÕES COM TERCEIROS(AS) RELACIONADOS AO USO DOS
          SERVIÇOS DA HAUSEFUL OU A PLATAFORMA DE HOST. SEM PREJUÍZO DA
          INDICAÇÃO DA HAUSEFUL COMO AGENTE DE COBRANÇA LIMITADA DE PAGAMENTOS
          DO(A) HOST PARA FINS DE ACEITAÇÃO DO PAGAMENTO DE USUÁRIOS(AS) EM
          FAVOR DO(A) HOST, COMO ESTABELECIDO NA CLÁUSULA 2 ACIMA, A HAUSEFUL
          EXPRESSAMENTE RENUNCIA QUALQUER RESPONSABILIDADE POR QUALQUER ATO OU
          OMISSÃO DO(A) HOST, QUALQUER HOST, QUALQUER USUÁRIO(A) OU TERCEIRO(A).
        </p>

        <p>
          <b>6.3. Não Garantia de Serviço.</b>
          A HAUSEFUL não garante a disponibilidade ou o tempo de atividade dos
          Serviços da HAUSEFUL ou da plataforma de HOST. O(A) HOST reconhece e
          concorda que os Serviços da HAUSEFUL ou a plataforma de HOST podem
          ficar indisponíveis a qualquer momento e por qualquer motivo (por
          exemplo, devido à manutenção programada ou falha da rede). Além disso,
          os Serviços da HAUSEFUL ou Plataforma de HOST podem estar sujeitos a
          limitações, atrasos e outros problemas inerentes à utilização de
          comunicações via Internet e eletrônicas. Igualmente a HAUSEFUL não
          será responsável por quaisquer atrasos, falhas de entrega ou outros
          danos, responsabilidades ou prejuízos resultantes de tais problemas.
        </p>

        <h2>7. Indenização</h2>

        <p>
          <b> 7.1. </b>
          O(A) HOST deverá indenizar, defender e isentar a HAUSEFUL e suas
          Afiliadas e seus respectivos(as) representantes, diretores(as),
          funcionários(as), agentes, sucessores(as) e cessionários(as) contra
          todas e quaisquer indenizações, despesas (incluindo honorários
          advocatícios), danos, sanções, multas, contribuições para a seguridade
          social e tributos decorrentes ou relacionados com: (a) o não
          cumprimento pelo(a) HOST das declarações, garantias e obrigações
          feitas sob o presente Contrato; (b) uma reclamação de terceiros(as)
          (incluindo Usuários(as), órgãos reguladores e autoridades
          governamentais), direta ou indiretamente relacionados(as) com a
          prestação de Serviços de HOST ou a utilização dos Serviços da HAUSEFUL
          pelo(a) HOST; (c) o não cumprimento por parte do(a) Usuário(a) ou
          do(a) HOST de sua obrigação de pagamento através do sistema de
          pagamento escolhido.
        </p>

        <p>
          <b>7.2.</b>
          Entre o(a) HOST e a HAUSEFUL, o(a) HOST é e será o único responsável
          pela prestação de Serviços de HOST e por seus(suas) HOSTs (conforme o
          caso). Assim, o (a) HOST deverá indenizar, defender e isentar a
          HAUSEFUL e suas Afiliadas e seus respectivos representantes,
          diretores(as), funcionários(as), agentes, sucessores(as) e
          cessionários(as) contra todas e quaisquer responsabilidades, despesas
          (incluindo honorários advocatícios), danos, sanções, multas,
          contribuições para a seguridade social e tributos decorrentes ou
          relacionados com a prestação de Serviços de HOST por seus(suas) HOSTs
          ou o uso dos Serviços da HAUSEFUL.
        </p>

        <h2>8. LIMITES DE RESPONSABILIDADE</h2>

        <p>
          A HAUSEFUL E SUAS AFILIADAS NÃO SERÃO RESPONSÁVEIS NOS TERMOS, OU EM
          RELAÇÃO, A ESTE CONTRATO, POR QUALQUER UM DOS ITENS ABAIXO, SEJA COM
          FUNDAMENTO NO CONTRATO, ATO ILÍCITO OU QUALQUER OUTRA TEORIA JURÍDICA,
          MESMO QUE UMA PARTE FORA INFORMADA SOBRE A POSSIBILIDADE DE TAIS
          DANOS: (I) QUAISQUER DANOS ACIDENTAIS, PUNITIVOS, ESPECIAIS,
          EXEMPLARES, CONSEQUENTES OU OUTROS DANOS INDIRETOS DE QUALQUER ESPÉCIE
          OU NATUREZA; OU (ii) DANOS MATERIAIS, PERDA OU IMPRECISÃO DE DADOS,
          LUCROS CESSANTES, PERDA DE RECEITA, DE LUCROS, DE USO OU DE OUTRA
          VANTAGEM ECONÔMICA PELO(A) HOST, HOST OU TERCEIROS(AS). COM EXCEÇÃO
          DAS OBRIGAÇÕES DA HAUSEFUL DE PAGAR OS VALORES DEVIDOS AO(À) HOST NOS
          TERMOS DA CLÁUSULA 2 ACIMA, MAS CONSIDERANDO QUAISQUER LIMITAÇÕES OU
          OUTRAS DISPOSIÇÕES CONSTANTES DO PRESENTE CONTRATO QUE POSSAM SER
          APLICÁVEIS, EM NENHUMA CIRCUNSTÂNCIA A RESPONSABILIDADE DA HAUSEFUL OU
          DE SUAS AFILIADAS AO ABRIGO DO PRESENTE CONTRATO EXCEDERÁ O VALOR DAS
          TAXAS DE SERVIÇO PAGAS OU DEVIDAS À HAUSEFUL NOS TERMOS DESTE
          DOCUMENTO NO PERÍODO DE 6 (SEIS) MESES IMEDIATAMENTE ANTERIORES AO
          EVENTO QUE DEU ORIGEM A TAL RECLAMAÇÃO. ESTAS LIMITAÇÕES NÃO TÊM A
          INTENÇÃO DE LIMITAR A RESPONSABILIDADE QUE NÃO PODE SER EXCLUÍDA PELA
          LEI APLICÁVEL.
        </p>

        <h2>9. Prazo e Rescisão</h2>

        <p>
          <b>9.1. Prazo.</b>
          O presente Contrato terá início na data em que for formalizado pelo(a)
          HOST (eletronicamente ou de outra forma) e permanecerá em vigor até
          que seja extinto na forma fixada neste documento.
        </p>

        <p>
          <b> 9.2. Rescisão. </b>
          Qualquer uma das partes poderá terminar o presente Contrato: (a) sem
          motivo, a qualquer momento, mediante envio de notificação à outra
          parte com 7 (sete) dias de antecedência, sem ônus para quaisquer das
          partes; (b) imediatamente, sem aviso prévio, por descumprimento deste
          Contrato pela outra parte; ou (c) imediatamente, sem aviso prévio, em
          caso de insolvência ou falência da outra parte, ou no momento em que a
          outra parte depositar ou apresentar um pedido de suspensão do
          pagamento (ou medida ou evento semelhante) contra a parte distratante.
        </p>

        <p>
          <b> 9.3. Efeitos da Extinção. </b>
          Após a rescisão do Contrato (exceto no caso de uma rescisão descrita
          na Cláusula 9.2., o(a) HOST e todos os(as) HOSTs, conforme o caso,
          deverão: (a) devolver imediatamente à HAUSEFUL todos os dispositivos
          da HAUSEFUL; e (b) excluir imediatamente e remover completamente a
          plataforma de HOST de quaisquer Dispositivos Fornecidos por HOST. As
          obrigações de pagamento pendentes sobreviverão à extinção do presente
          Contrato.
        </p>

        <h2>10. Relação entre as partes</h2>

        <p>
          <b> 10.1. </b>
          Exceto como expressamente previsto neste Contrato, no que diz respeito
          à HAUSEFUL agir como o agente limitado de cobrança de pagamento,
          apenas para fins de cobrança de pagamentos devidos pelos(as)
          Usuários(as) em favor do(a) HOST, a relação entre as partes nos termos
          deste Contrato é de empreendedores independentes. As partes concordam
          expressamente que: (a) o presente Contrato não é um contrato de
          trabalho, nem cria uma relação de trabalho (inclusive sob a
          perspectiva da lei trabalhista, tributária ou da segurança social),
          entre a HAUSEFUL e o(a) HOST ou entre a HAUSEFUL e qualquer HOST; e
          (b) não existe nenhuma relação de joint venture, parceria, ou agência
          entre a HAUSEFUL e o(a) HOST ou a HAUSEFUL e qualquer HOST.
        </p>

        <p>
          <b> 10.2. </b>
          O(A) HOST não tem autoridade para vincular a HAUSEFUL e se compromete
          a não se apresentar como um(a) empregado(a), agente ou representante
          autorizado(a) da HAUSEFUL ou suas afiliadas, assim como assegurará que
          nenhum(a) HOST se apresentará como tal.
        </p>

        <p>
          <b>10.3.</b>
          O(A) HOST reconhece expressamente e consente que ao formalizar as
          condições deste Contrato intenciona prestar Serviços de HOST de forma
          rotineira e, desta forma, a HAUSEFUL considerará o(a) HOST e
          seus(suas) HOSTs como sujeitos passivos, se assim previsto na lei
          tributária aplicável.
        </p>

        <h2>11. Disposições Gerais</h2>

        <p>
          <b>11.1. Modificação.</b>
          A HAUSEFUL reserva-se o direito de modificar os termos e condições
          deste Contrato ou do Adendo de HOST, a qualquer momento, e entrará em
          vigor mediante a publicação de uma versão atualizada do presente
          Contrato ou Adendo do HOST, conforme o caso, no portal on-line
          disponível para o(a) HOST sobre os Serviços da HAUSEFUL. A HAUSEFUL
          reserva o direito de alterar qualquer informação referenciada em
          hyperlinks a partir deste Contrato de tempos em tempos. O(A) HOST
          neste ato reconhece e concorda que, ao utilizar os Serviços da
          HAUSEFUL, ou ao baixar, instalar ou usar a plataforma de HOST, o(a)
          HOST está vinculado a quaisquer futuras alterações e aditamentos ao
          presente Contrato, informações aqui referenciadas em hiperlinks, ou
          documentos aqui incorporados, incluindo com respeito a cálculos do
          preço. O uso continuado dos Serviços da HAUSEFUL ou da plataforma de
          HOST após qualquer mudança constituirá um consentimento por parte
          do(a) HOST para tal mudança.
        </p>

        <p>
          <b> 11.2. Termos Suplementares. </b>
          Termos suplementares poderão ser aplicados ao uso dos Serviços da
          HAUSEFUL pelo(a) HOST e pelo(a) HOST, como políticas de uso ou termos
          relacionados a determinadas características e funcionalidades que
          poderão sofrer alterações a qualquer tempo (“Termos Suplementares”).
          O(A) HOST poderá receber determinados Termos Suplementares a qualquer
          momento. Os Termos Suplementares são adicionais e deverão ser
          considerados parte do presente Contrato. Os Termos Suplementares
          prevalecerão sobre este Contrato caso ocorra algum conflito.
        </p>

        <p>
          <b>11.3. Divisibilidade das Cláusulas.</b>
          Se qualquer disposição do presente Contrato for considerada ilegal,
          inválida ou inexequível, no todo ou em parte, sob qualquer lei, tal
          disposição ou parte dela deverá, em sua extensão, ser considerada como
          não sendo parte do presente Contrato, mas a legalidade, validade e
          exequibilidade do restante do presente Contrato, não será afetada.
          Nesta situação, as partes devem substituir a (parte da) disposição
          ilegal, inválida ou inexequível com uma (parte de uma) disposição que
          seja legal, válida e exequível e que tenha, na maior medida possível,
          um efeito semelhante ao daquela (parte daquela) considerada ilegal,
          inválida ou inexequível, considerando o conteúdo e finalidade do
          presente Contrato.
        </p>

        <p>
          <b> 11.4. Cessão. </b>
          O(A) HOST não poderá ceder ou transferir este Contrato ou quaisquer
          direitos ou obrigações aqui estabelecidas, no todo ou em parte, sem o
          prévio consentimento por escrito da HAUSEFUL. A HAUSEFUL poderá ceder
          ou transferir este Contrato ou quaisquer direitos ou obrigações aqui
          estabelecidas, no todo ou em parte, nos termos deste Contrato, a
          qualquer momento e sem consentimento, notificando o(a) HOST de
          referida cessão.
        </p>

        <p>
          <b>11.5. Totalidade do Contrato.</b>
          Este Contrato, incluindo preâmbulo e todos os Termos Suplementares,
          constitui a totalidade do acordo e entendimento das partes com relação
          ao objeto em questão e este documento imediatamente encerra, substitui
          e supera todos os acordos, contratos e acertos anteriores entre o(a)
          HOST e qualquer Afiliada da HAUSEFUL. Neste Contrato, as palavras
          “incluindo” e “incluí” significa “incluindo, mas não limitado a”.
        </p>

        <p>
          <b>11.6. Não Há Terceiros(as) Beneficiários(as).</b>
          Salvo a disposição em contrário prevista na Cláusula 1.5 acima, o(a)
          HOST reconhece que não existem terceiros(as) beneficiários(as) do
          presente Contrato. Nada contido neste Contrato destina-se a criar
          quaisquer reivindicações de terceiros(as) beneficiários(as) ou deve
          ser interpretado como tal.
        </p>

        <p>
          <b>11.7. Comunicados.</b>
          Qualquer notificação entregue pela HAUSEFUL ao(à) HOST no âmbito do
          presente Contrato será entregue por e-mail (correio eletrônico) para o
          endereço de e-mail cadastrado na conta do(a) HOST ou através de
          postagem no portal on-line disponível para o(a) HOST em relação aos
          Serviços da HAUSEFUL. Qualquer aviso emitido pelo(a) HOST para a
          HAUSEFUL no âmbito do presente Contrato será entregue através de
          contato com a HAUSEFUL em www.hauseful.com na seção “Fale Conosco”.
          Avisos adicionais específicos para o Território podem ser necessários
          de tempos em tempos.
        </p>

        <h2>12. Lei Aplicável</h2>

        <p>
          Salvo disposição em contrário prevista neste Contrato, o presente
          Contrato deve ser exclusivamente regido e interpretado de acordo com
          as leis do Brasil. Quaisquer disputas, conflitos ou controvérsias
          decorrentes de ou de alguma forma relacionadas ao Contrato, incluindo
          com relação à sua validade, sua interpretação ou o seu caráter
          executório, deverão ser resolvidas no foro de domicílio do(a) HOST. Ao
          clicar no “Eu aceito” ou assinar abaixo (o que for exigido pela
          legislação aplicável), o(a) HOST expressamente reconhece ter lido,
          compreendido e adotado medidas para interpretar cuidadosamente as
          consequências deste Contrato. O(A) HOST concorda em vincular-se aos
          termos e condições deste Contrato, e ainda ser legalmente capaz de
          celebrar este Contrato com a HAUSEFUL.
        </p>
        <p style="text-align: center">
          {{ locationAndDate }}
        </p>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import moment from 'moment'

export default {
  name: 'ModalOnboardingTerms',

  components: {
    Modal,
  },

  computed: {
    locationAndDate() { 
      moment.locale('pt-br')
      const date = moment().format('LL')
      return `Florianópolis, ${date}`
    }
  },
}
</script>
